import { extendTheme } from "@chakra-ui/react";
import { StepsTheme as Steps } from "chakra-ui-steps";
import { LinksTheme as Links } from "./components/links";
import { ListsTheme as List } from "./components/lists";
import { InputsTheme as Input } from "./components/inputs";

export const themeColors = {
	white: "#FFFFFF",
	offWhite: "#F5F5F5", // Renamed `white2` for clarity
	primary: "rgb(236,122,29)", // Bright orange
	secondary: "#707070", // Grayish secondary
	border: "#D7D7D7",
	warning: "#FEC057", // Orange warning
	danger: "#FFA5A8", // Light red danger
	orange: {
		400: "#F5904E", // Vibrant orange
		500: "#DD6B20", // Slightly darker orange
		600: "#C05621" // Dark orange
	},
	red: {
		500: "#D56E6E" // Muted red
	},
	crimson: {
		500: "#DB5050", // Bright crimson
		600: "#BD4444" // Darker crimson
	},
	gray: {
		100: "#F1F1F1", // Very light gray
		200: "#D7D7D7", // Matches `border`
		300: "#DDDDDD", // Light gray
		400: "#BBBBBB", // Medium gray
		500: "#8F8F8F", // Slightly darker gray
		600: "#808080", // Standard gray
		700: "#606060", // Darker gray
		800: "#404040", // Dark gray
		900: "#E7E7E7" // Replaced by 1500 (lighter gray)
	}
};

const LegalTheme = extendTheme({
	styles: {
		global: () => ({
			html: {
				height: "100%",
				width: "100%"
			},
			body: {
				height: "100%",
				width: "100%",
				bg: "#f3f3f3"
			},
			"#root": {
				height: "100%",
				width: "100%"
			}
		})
	},
	colors: themeColors,
	components: {
		Steps,
		Links,
		Input,
		List
	}
});

export default LegalTheme;
